export class Supplier {
    email: string;
    companyName: string;
    supplierID: string;
    swordsVN: string;
    flandersVN: string;
    llanberisVN: string;
    lasAngelesVN: string;

    static jsonToSupplier(supplierJson: any): Supplier {
        const newSupplier = new Supplier();
        if (supplierJson && !supplierJson.UserAttributes) {
            return Object.assign(newSupplier, supplierJson);
        }
        supplierJson.UserAttributes.forEach((attribute) => {
            switch (attribute.Name) {
                case 'email':
                    newSupplier.email = attribute.Value;
                    break;
                case 'custom:CompanyName':
                    newSupplier.companyName = attribute.Value;
                    break;
                case 'custom:SiemensSupplierID':
                    newSupplier.supplierID = attribute.Value;
                    break;
                case 'custom:SwordsVendorNumber':
                    newSupplier.swordsVN = attribute.Value;
                    break;
                case 'custom:FlandersVendorNumber':
                    newSupplier.flandersVN = attribute.Value;
                    break;
                case 'custom:LlanberisVendorNumber':
                    newSupplier.llanberisVN = attribute.Value;
                    break;
                case 'custom:LasAngelesVendorNumber':
                    newSupplier.lasAngelesVN = attribute.Value;
                    break;
            }
        });
        return newSupplier;
    }
}
